module.exports = __webpack_public_path__ + "static/media/bw.16dfb7f8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/bw.svg
// module id = 76
// module chunks = 0